import { i18n } from '@/locale'
import moment from 'moment'

function getGuestFullName (guest) {
  const firstName = getGuestName(guest)
  const lastName = getGuestLastName(guest)
  return lastName ? `${firstName} ${lastName}` : firstName
}

function getGuestName (guest) {
  if (!guest.profile) {
    return i18n.t('guest.no_name')
  }
  return guest.profile.name
    ? guest.profile.name
    : i18n.t('guest.no_name')
}
function getGuestLastName (guest) {
  if (!guest.profile) {
    return ''
  }
  return guest.profile.lastName
    ? guest.profile.lastName
    : ''
}

function isGuestCheckedOut (guest) {
  return guest.checkout && moment(guest.checkout).isBefore(moment())
}

export {
  getGuestFullName,
  isGuestCheckedOut
}
